import React from "react";
import { FaFacebookF } from "react-icons/fa";
import { BsTwitter } from "react-icons/bs";
import { FaLinkedinIn } from "react-icons/fa";
import { MdLocationPin } from "react-icons/md";
import { MdOutlineEmail } from "react-icons/md";
import { BiPhoneCall } from "react-icons/bi";
import { FaFax } from "react-icons/fa";
import "./Footer.css";

const Footer = () => {
  return (
    <>
      <div className="footer-container">
        <div className="footer-container-right__right-info">
          <div className="footer-container-right__right-info-head">
            <MdLocationPin className="footer-container-right__right-icon " />
            <h3 className="footer-container-right__right-info-title">
              Address
            </h3>
          </div>
          <h5 className="footer-container-right__right-info-text">
            501 S Lincoln Ave.
          </h5>
          <h5 className="footer-container-right__right-info-text">
            Clearwater, FL 33756
          </h5>
        </div>
        <div className="footer-container-right__right-info">
          <div className="footer-container-right__right-info-head">
            <MdOutlineEmail className="footer-container-right__right-icon" />
            <h3 className="footer-container-right__right-info-title ">
              Email Us
            </h3>
          </div>
          <h5 className="footer-container-right__right-info-text">
            info@lincourtpharmacy
          </h5>
        </div>
        <div className="footer-container-right__right-info">
          <div className="footer-container-right__right-info-head">
            <BiPhoneCall className="footer-container-right__right-icon" />
            <h3 className="footer-container-right__right-info-title">
              Call Us
            </h3>
          </div>
          <h5 className="footer-container-right__right-info-text">
            (727) 447-4248
          </h5>
        </div>
        <div className="footer-container-right__right-info">
          <div className="footer-container-right__right-info-head">
            <FaFax className="footer-container-right__right-icon" />
            <h3 className="footer-container-right__right-info-title">Fax Us</h3>
          </div>
          <h5 className="footer-container-right__right-info-text">
            (727) 447-4248
          </h5>
        </div>
        <div className="footer-container-right__right-info">
          <div className="footer-container-right__right-info-head">
            <FaFax className="footer-container-right__right-icon" />
            <h3 className="footer-container-right__right-info-title">Media</h3>
          </div>
          <div className="footer-container-left-social-icons">
            <FaFacebookF className="footer-container-left-icon" />
            <BsTwitter className="footer-container-left-icon" />
            <FaLinkedinIn className="footer-container-left-icon" />
          </div>
        </div>
      </div>
      <div className="footer-container-bottom">
        <div className="footer-container-bottom-left">
          &copy; ALL RIGHT RESERVED
        </div>
        <div className="footer-container-bottom-right">
          <div className="footer-container-bottom-right-info">
            <span className="footer-container-bottom-right-info-text">
              TERMS & CONDITION
            </span>
            <span className="footer-container-bottom-right-info-text">
              PRIVACY POLICY
            </span>
            <span className="footer-container-bottom-right-info-text">
              CONTACT US
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
